<h1 style="color: #2A6ECF;">HISTÓRICO</h1>
<div class="history-container">
<tds-table
        vertical-dividers="false"
        compact-design="false"
        no-min-width
        responsive
        (tdsSort)="sort($event)"
        >
      <tds-table-toolbar
            table-title="Filter"
            filter
            (tdsFilter)="handleFilter($event)"
        ></tds-table-toolbar>
      <tds-table-header>

            <tds-header-cell
            cell-key="action"
            cell-value="Actions"
            sortable="false"
            ></tds-header-cell>

          <tds-header-cell
            cell-key="reservationDate"
            cell-value="Reservation Date"
            sortable="true"
            ></tds-header-cell>

          <tds-header-cell
            cell-key="tableName"
            cell-value="Table"
            sortable="true"
            ></tds-header-cell>

          <tds-header-cell
            cell-key="building"
            cell-value="Building"
            sortable="true"
            ></tds-header-cell>

          <tds-header-cell
            cell-key="region"
            cell-value="Region"
            sortable="true"
            ></tds-header-cell>

      </tds-table-header>
      <tds-table-body>

            @for( row of tableData(); track `${row.reservationId}_${$index}`){

              <tds-table-body-row>
                  <tds-body-cell cell-key="action">
                        @if(canCancelReservation(row.reservationDate)){
                              <tds-button variant="danger" text="Cancelar" size="sm" (click)="cancelReservation(row!)"></tds-button>
                        }
                  </tds-body-cell>
                  <tds-body-cell cell-key="reservationDate">
                        {{ row.reservationDate | date:'dd/MM/yyyy' }}
                  </tds-body-cell>
                  <tds-body-cell cell-key="tableName">
                        {{ row.tableName }}
                  </tds-body-cell>
                  <tds-body-cell cell-key="building">
                        {{ row.building }}
                  </tds-body-cell>
                  <tds-body-cell cell-key="region">
                        {{ row.region }}
                  </tds-body-cell>                
              </tds-table-body-row>

            }
            
      </tds-table-body>
      <tds-table-footer
            pagination
            [pages]="pages()"
            (tdsPagination)="handlePagination($event)"
            [rowsPerPageValues]="rowsPerPageValuesArray"
      ></tds-table-footer>
        
</tds-table>
</div>
